import { ActionTypes } from "../constants/action_types";
const initialValue = null;

export const userAddressReducer = (state=initialValue,{type,userAddress})=>{
    switch(type){
        case ActionTypes.USER_ADDRESS : 
        return {...state,userAddress}
        default : return state;
    }
}